/**
 * @generated SignedSource<<0dea45987fbe7a6891fbf2b84058db14>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SimpleSortRupturesArgs = {
  ascending?: boolean | null | undefined;
  attribute?: string | null | undefined;
};
export type RuptureAnimationPageQuery$variables = {
  after?: string | null | undefined;
  fault_system: string;
  first: number;
  location_ids: ReadonlyArray<string | null | undefined>;
  maximum_mag?: number | null | undefined;
  maximum_rate?: number | null | undefined;
  minimum_mag?: number | null | undefined;
  minimum_rate?: number | null | undefined;
  model_id: string;
  radius_km: number;
  sortby?: ReadonlyArray<SimpleSortRupturesArgs | null | undefined> | null | undefined;
};
export type RuptureAnimationPageQuery$data = {
  readonly SOLVIS_filter_ruptures:
    | {
        readonly total_count: number | null | undefined;
      }
    | null
    | undefined;
  readonly SOLVIS_locations_by_id:
    | {
        readonly edges: ReadonlyArray<
          | {
              readonly node:
                | {
                    readonly radius_geojson: any | null | undefined;
                  }
                | null
                | undefined;
            }
          | null
          | undefined
        >;
      }
    | null
    | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"RuptureAnimationPage_queryRoot">;
};
export type RuptureAnimationPageQuery = {
  response: RuptureAnimationPageQuery$data;
  variables: RuptureAnimationPageQuery$variables;
};

const node: ConcreteRequest = (function () {
  var v0 = {
      defaultValue: null,
      kind: "LocalArgument",
      name: "after",
    },
    v1 = {
      defaultValue: null,
      kind: "LocalArgument",
      name: "fault_system",
    },
    v2 = {
      defaultValue: null,
      kind: "LocalArgument",
      name: "first",
    },
    v3 = {
      defaultValue: null,
      kind: "LocalArgument",
      name: "location_ids",
    },
    v4 = {
      defaultValue: null,
      kind: "LocalArgument",
      name: "maximum_mag",
    },
    v5 = {
      defaultValue: null,
      kind: "LocalArgument",
      name: "maximum_rate",
    },
    v6 = {
      defaultValue: null,
      kind: "LocalArgument",
      name: "minimum_mag",
    },
    v7 = {
      defaultValue: null,
      kind: "LocalArgument",
      name: "minimum_rate",
    },
    v8 = {
      defaultValue: null,
      kind: "LocalArgument",
      name: "model_id",
    },
    v9 = {
      defaultValue: null,
      kind: "LocalArgument",
      name: "radius_km",
    },
    v10 = {
      defaultValue: null,
      kind: "LocalArgument",
      name: "sortby",
    },
    v11 = {
      kind: "Variable",
      name: "location_ids",
      variableName: "location_ids",
    },
    v12 = [v11 /*: any*/],
    v13 = {
      kind: "Variable",
      name: "radius_km",
      variableName: "radius_km",
    },
    v14 = {
      alias: null,
      args: [
        v13 /*: any*/,
        {
          kind: "Literal",
          name: "style",
          value: {
            fill_color: "royalblue",
            fill_opacity: 0.5,
            stroke_color: "royalblue",
            stroke_opacity: 0.2,
            stroke_width: 3,
          },
        },
      ],
      kind: "ScalarField",
      name: "radius_geojson",
      storageKey: null,
    },
    v15 = [
      {
        kind: "Variable",
        name: "after",
        variableName: "after",
      },
      {
        fields: [
          {
            kind: "Variable",
            name: "fault_system",
            variableName: "fault_system",
          },
          v11 /*: any*/,
          {
            kind: "Variable",
            name: "maximum_mag",
            variableName: "maximum_mag",
          },
          {
            kind: "Variable",
            name: "maximum_rate",
            variableName: "maximum_rate",
          },
          {
            kind: "Variable",
            name: "minimum_mag",
            variableName: "minimum_mag",
          },
          {
            kind: "Variable",
            name: "minimum_rate",
            variableName: "minimum_rate",
          },
          {
            kind: "Variable",
            name: "model_id",
            variableName: "model_id",
          },
          v13 /*: any*/,
        ],
        kind: "ObjectValue",
        name: "filter",
      },
      {
        kind: "Variable",
        name: "first",
        variableName: "first",
      },
      {
        kind: "Variable",
        name: "sortby",
        variableName: "sortby",
      },
    ],
    v16 = {
      alias: null,
      args: null,
      kind: "ScalarField",
      name: "total_count",
      storageKey: null,
    },
    v17 = {
      alias: null,
      args: null,
      kind: "ScalarField",
      name: "id",
      storageKey: null,
    };
  return {
    fragment: {
      argumentDefinitions: [
        v0 /*: any*/,
        v1 /*: any*/,
        v2 /*: any*/,
        v3 /*: any*/,
        v4 /*: any*/,
        v5 /*: any*/,
        v6 /*: any*/,
        v7 /*: any*/,
        v8 /*: any*/,
        v9 /*: any*/,
        v10 /*: any*/,
      ],
      kind: "Fragment",
      metadata: null,
      name: "RuptureAnimationPageQuery",
      selections: [
        {
          alias: null,
          args: v12 /*: any*/,
          concreteType: "LocationDetailConnection",
          kind: "LinkedField",
          name: "SOLVIS_locations_by_id",
          plural: false,
          selections: [
            {
              alias: null,
              args: null,
              concreteType: "LocationDetailEdge",
              kind: "LinkedField",
              name: "edges",
              plural: true,
              selections: [
                {
                  alias: null,
                  args: null,
                  concreteType: "LocationDetail",
                  kind: "LinkedField",
                  name: "node",
                  plural: false,
                  selections: [v14 /*: any*/],
                  storageKey: null,
                },
              ],
              storageKey: null,
            },
          ],
          storageKey: null,
        },
        {
          alias: null,
          args: v15 /*: any*/,
          concreteType: "RuptureDetailConnection",
          kind: "LinkedField",
          name: "SOLVIS_filter_ruptures",
          plural: false,
          selections: [v16 /*: any*/],
          storageKey: null,
        },
        {
          args: v15 /*: any*/,
          kind: "FragmentSpread",
          name: "RuptureAnimationPage_queryRoot",
        },
      ],
      type: "Query",
      abstractKey: null,
    },
    kind: "Request",
    operation: {
      argumentDefinitions: [
        v2 /*: any*/,
        v0 /*: any*/,
        v8 /*: any*/,
        v1 /*: any*/,
        v3 /*: any*/,
        v9 /*: any*/,
        v6 /*: any*/,
        v4 /*: any*/,
        v7 /*: any*/,
        v5 /*: any*/,
        v10 /*: any*/,
      ],
      kind: "Operation",
      name: "RuptureAnimationPageQuery",
      selections: [
        {
          alias: null,
          args: v12 /*: any*/,
          concreteType: "LocationDetailConnection",
          kind: "LinkedField",
          name: "SOLVIS_locations_by_id",
          plural: false,
          selections: [
            {
              alias: null,
              args: null,
              concreteType: "LocationDetailEdge",
              kind: "LinkedField",
              name: "edges",
              plural: true,
              selections: [
                {
                  alias: null,
                  args: null,
                  concreteType: "LocationDetail",
                  kind: "LinkedField",
                  name: "node",
                  plural: false,
                  selections: [v14 /*: any*/, v17 /*: any*/],
                  storageKey: null,
                },
              ],
              storageKey: null,
            },
          ],
          storageKey: null,
        },
        {
          alias: null,
          args: v15 /*: any*/,
          concreteType: "RuptureDetailConnection",
          kind: "LinkedField",
          name: "SOLVIS_filter_ruptures",
          plural: false,
          selections: [
            v16 /*: any*/,
            {
              alias: null,
              args: null,
              concreteType: "PageInfo",
              kind: "LinkedField",
              name: "pageInfo",
              plural: false,
              selections: [
                {
                  alias: null,
                  args: null,
                  kind: "ScalarField",
                  name: "hasNextPage",
                  storageKey: null,
                },
                {
                  alias: null,
                  args: null,
                  kind: "ScalarField",
                  name: "endCursor",
                  storageKey: null,
                },
              ],
              storageKey: null,
            },
            {
              alias: null,
              args: null,
              concreteType: "RuptureDetailEdge",
              kind: "LinkedField",
              name: "edges",
              plural: true,
              selections: [
                {
                  alias: null,
                  args: null,
                  concreteType: "CompositeRuptureDetail",
                  kind: "LinkedField",
                  name: "node",
                  plural: false,
                  selections: [
                    {
                      alias: null,
                      args: null,
                      kind: "ScalarField",
                      name: "rupture_index",
                      storageKey: null,
                    },
                    {
                      alias: null,
                      args: null,
                      kind: "ScalarField",
                      name: "fault_surfaces",
                      storageKey: null,
                    },
                    {
                      alias: null,
                      args: null,
                      kind: "ScalarField",
                      name: "magnitude",
                      storageKey: null,
                    },
                    {
                      alias: null,
                      args: null,
                      kind: "ScalarField",
                      name: "rate_weighted_mean",
                      storageKey: null,
                    },
                    {
                      alias: null,
                      args: null,
                      kind: "ScalarField",
                      name: "area",
                      storageKey: null,
                    },
                    {
                      alias: null,
                      args: null,
                      kind: "ScalarField",
                      name: "length",
                      storageKey: null,
                    },
                    v17 /*: any*/,
                    {
                      alias: null,
                      args: null,
                      kind: "ScalarField",
                      name: "__typename",
                      storageKey: null,
                    },
                  ],
                  storageKey: null,
                },
                {
                  alias: null,
                  args: null,
                  kind: "ScalarField",
                  name: "cursor",
                  storageKey: null,
                },
              ],
              storageKey: null,
            },
          ],
          storageKey: null,
        },
        {
          alias: null,
          args: v15 /*: any*/,
          filters: ["filter", "sortby"],
          handle: "connection",
          key: "RuptureAnimationPage_queryRoot_SOLVIS_filter_ruptures",
          kind: "LinkedHandle",
          name: "SOLVIS_filter_ruptures",
        },
      ],
    },
    params: {
      cacheID: "53adab2048c5eac96250a91ebe25d0fc",
      id: null,
      metadata: {},
      name: "RuptureAnimationPageQuery",
      operationKind: "query",
      text: 'query RuptureAnimationPageQuery(\n  $first: Int!\n  $after: String\n  $model_id: String!\n  $fault_system: String!\n  $location_ids: [String]!\n  $radius_km: Int!\n  $minimum_mag: Float\n  $maximum_mag: Float\n  $minimum_rate: Float\n  $maximum_rate: Float\n  $sortby: [SimpleSortRupturesArgs]\n) {\n  SOLVIS_locations_by_id(location_ids: $location_ids) {\n    edges {\n      node {\n        radius_geojson(radius_km: $radius_km, style: {stroke_color: "royalblue", stroke_width: 3, stroke_opacity: 0.2, fill_opacity: 0.5, fill_color: "royalblue"})\n        id\n      }\n    }\n  }\n  SOLVIS_filter_ruptures(first: $first, after: $after, filter: {model_id: $model_id, fault_system: $fault_system, location_ids: $location_ids, radius_km: $radius_km, minimum_mag: $minimum_mag, maximum_mag: $maximum_mag, minimum_rate: $minimum_rate, maximum_rate: $maximum_rate}, sortby: $sortby) {\n    total_count\n  }\n  ...RuptureAnimationPage_queryRoot_45dR5v\n}\n\nfragment RuptureAnimationPage_queryRoot_45dR5v on Query {\n  SOLVIS_filter_ruptures(first: $first, after: $after, filter: {model_id: $model_id, fault_system: $fault_system, location_ids: $location_ids, radius_km: $radius_km, minimum_mag: $minimum_mag, maximum_mag: $maximum_mag, minimum_rate: $minimum_rate, maximum_rate: $maximum_rate}, sortby: $sortby) {\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    edges {\n      node {\n        rupture_index\n        fault_surfaces\n        magnitude\n        rate_weighted_mean\n        area\n        length\n        id\n        __typename\n      }\n      cursor\n    }\n  }\n}\n',
    },
  };
})();

(node as any).hash = "7bfdcb27ab3cc9835b1a9d72fcd6bb77";

export default node;
